// extracted by mini-css-extract-plugin
export var backdropBlur = "_ir-0";